import React from "react";
import { useSelector } from "react-redux";
import { strings } from "../../common/i18n";
import { LocationForm } from "../../common/components";
import MenuOptions from "../components/common/MenuOptions";
import MatReactTable from "../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";

/**
 * Locations Table Component
 */

export default () => {
    const { locations } = useSelector((state) => state);

    const {
        columns,
        data,
        rowActions,
        error,
        onCsvMap,
        onCsvUpload,
        onDataItemAdd,
        onDataItemClear,
        onDataItemSet,
        onDataSave,
        optionOpen,
        onMenuOpen,
        onMenuClose,
        toolBarComponents
    } = useColumnsRows();

    return (
        <>
            <MatReactTable
                persistKey="manageLocations"
                columns={columns}
                data={data}
                loading={false}
                rowActions={rowActions}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noAssets")}
            />

            <MenuOptions
                columns={columns}
                data={data}
                header={strings("location")}
                optionOpen={optionOpen}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                error={error}
                csvFileName={strings("locations")}
                onCsvMap={onCsvMap}
                onCsvUpload={onCsvUpload}
                // onDataMap={onDataMap}
                onDataItemAdd={onDataItemAdd}
                onDataItemClear={onDataItemClear}
                onDataItemSet={onDataItemSet}
                onDataSave={onDataSave}
                dataItem={locations.item}
                FormComponent={LocationForm}
            />
        </>
    );
};
